export const returnStatusTabs = [
  { label: "All", value: "ALL" },
  { label: "In Review", value: "REVIEW" },
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
];

export const stockRemovalStatusTabs = [
  { label: "All", value: "ALL" },
  { label: "In Review", value: "REVIEW" },
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Draft", value: "DRAFT" },
];

export const approvalStatusTabs = stockRemovalStatusTabs;
